
import { Component, Prop, Vue, Ref } from 'nuxt-property-decorator';
import { type NestedPage, PageType } from '../../../services/fourwaves/models';
import { type TranslateResult } from '../../../types/i18n';
import WebsiteNavigationLink from './WebsiteNavigationLink.vue';
import WebsiteNavigationDropdown from './WebsiteNavigationDropdown.vue';

@Component({ components: { WebsiteNavigationLink, WebsiteNavigationDropdown } })
export default class WebsiteNavigationList extends Vue {
  @Prop({ type: Array, default: () => [] }) nestedPages!: NestedPage[];
  @Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;

  @Ref() readonly navigationList?: HTMLElement;
  @Ref() readonly navigationItem?: HTMLElement[];

  readonly PageType = PageType;

  overflowPages: NestedPage[] = [];
  private resizeObserver?: ResizeObserver;

  get rootTagName(): string {
    return !this.readOnly ? 'nav' : 'div';
  }

  get rootAttributes(): Record<string, TranslateResult> {
    return !this.readOnly ? { 'aria-label': this.$t('shared.navigation.aria_main_navigation') } : {};
  }

  async mounted(): Promise<void> {
    if (!this.navigationList) return;

    this.resizeObserver = new ResizeObserver(this.updateOverflow.bind(this));
    this.resizeObserver.observe(this.navigationList);

    await this.$nextTick();
    this.updateOverflow();
  }

  beforeDestroy(): void {
    if (!this.resizeObserver) return;

    this.resizeObserver.disconnect();
  }

  public getTabIndex(page: NestedPage): number {
    return this.overflowPages.some(p => p.id === page.id) ? -1 : 0;
  }

  private updateOverflow(): void {
    requestAnimationFrame(() => {
      if (!this.navigationItem || !this.navigationItem.length) return;

      const firstItemTop = this.navigationItem[0].offsetTop;

      const overflowPageIds = this.navigationItem
        .filter(item => item && item.offsetTop > firstItemTop)
        .map(({ dataset }) => dataset.id);

      this.overflowPages = this.nestedPages.filter(page => overflowPageIds.includes(page.id.toString()));
    });
  }
}
